import { AppRoutes } from '@types';

import { CookieHelper } from './cookie';

const checkAndRefreshAccessToken = async (callback: () => void) => {
  const refreshToken = CookieHelper.get('refresh_token');
  const refreshResponse = await fetch(
    new URL(
      '/api-jwt-token/refresh/',
      process.env.NODE_ENV === 'development' ? process.env.NEXT_PUBLIC_API_BASE_PATH : window.location.origin,
    ),
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh: refreshToken }),
      credentials: 'include',
    },
  );
  if (refreshResponse.status === 200) {
    const { access: newAccessToken } = await refreshResponse.json();
    CookieHelper.set('access_token', newAccessToken);
    callback();
  } else {
    CookieHelper.remove('access_token');
    CookieHelper.remove('refresh_token');
    window.location.replace(`/cal${AppRoutes.login}`);
  }
};

export const AuthHelper = { checkAndRefreshAccessToken };
